(function () {
  'use strict';

  class HistExpurgoCtrl {
    constructor($filter, HistExpurgo, ServiceVfiltro, FactoryVfiltro, Keys, VtabelaFactory, AlertasEnum, moment, $translate, Authenticator, MeasurementUnitConverterService) {
      this.histExpurgoService = HistExpurgo;
      this.keys = Keys;
      this.filter = $filter;
      this.vtabelaFactory = VtabelaFactory;
      this.serviceVfiltro = ServiceVfiltro;
      this.alertasEnum = AlertasEnum;
      this.moment = moment;
      this.translate = $translate;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator = Authenticator;
      this.authenticator.getUser().then(user => {
        this.dateTimeFormat = this.measurementUnitConverterService.getDateTimeFormat(user.measurementUnits.dateTimeFormat);
      });
      this.vtabela = null;
      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: this.keys.dateTime.name,
          time: true,
          maxDate: this.moment().endOf('day').format(),
          dateLimit: 30,
          defaultValues: {
            hoje: {
              active: true
            },
            ontem: {
              active: true
            },
            ultimos7dias: {
              active: true
            },
            ultimos30dias: {
              active: true
            }
          }
        },
        {
          name: 'uoId',
          key: Keys.uo.name
        },
        {
          name: 'veiculoIds',
          key: this.keys.veiculos.name,
          size: 6
        },
        {
          name: 'tipo-evento',
          key: this.keys.tipo.name,
          size: 6,
          hasNivel: false
        }
      ]))
      .then((filtro) => {
        this.filtro = filtro;
        this.consultar();
        this.vtabela = this.vtabelaFactory.get(this.initVtabela(), this.serviceVfiltro.factoryVfiltro.user, 'expurgos');
      });
    }

    initVtabela() {
      let objVtabela = {
        appScopeProvider: this,
        enableRowSelection: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        exportsCsv: false,
        enableSelectAll: false,
        showColumnFooter: true,
        isRowSelectable: () => {
          return false;
        },
        columnDefs: [
            {
              name: 'veiculo',
              displayName: this.translate.instant('core-permissoes.purge.vehicle'),
              type: 'string',
              pinnedLeft: true,
              filterCellFiltered: true,
              enableHiding: false
            },
            {
              name: 'uo',
              displayName: this.translate.instant('core-permissoes.purge.Ou'),
              enableHiding: false,
              filterCellFiltered: true,
              headerCellClass: 'icon-info-tooltip',
              headerTooltip: this.translate.instant('core-permissoes.purge.vehicleToolTip')
            },
            {
              name: 'evento',
              displayName: this.translate.instant('core-permissoes.purge.eventType'),
              filterCellFiltered: true,
              enableHiding: false
            },
            {
              name: 'dataHoraInicio',
              displayName: this.translate.instant('core-permissoes.purge.startDateTime'),
              type: 'date',
              cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
              cellClass: 'text-center',
              filterCellFiltered: true
            },
            {
              name: 'dataHoraFim',
              displayName: this.translate.instant('core-permissoes.purge.endDateTime'),
              type: 'date',
              cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
              cellClass: 'text-center',
              filterCellFiltered: true
            },
            {
              name: 'responsavel',
              displayName: this.translate.instant('core-permissoes.purge.responsible'),
              filterCellFiltered: true
            },
            {
              name: 'justificativa',
              displayName: this.translate.instant('core-permissoes.purge.justification'),
              filterCellFiltered: true
            }
        ]
      };
      return objVtabela;
    }

    getItemVtabela(item) {
      return {
        veiculo: this.getVeiculo(item.veiculo),
        uo: item.uo.nome,
        evento: this.getEvento(item.tipoEvento),
        dataHoraInicio: item.inicio,
        dataHoraFim: item.fim,
        responsavel: item.responsavel,
        justificativa: item.justificativa
      };
    }

    getEvento(evento) {
      return this.translate.instant(this.alertasEnum.getAlerta(evento).descricao);
    }

    getVeiculo(veiculo) {
      return veiculo.prefixo + ' - ' + veiculo.placa;
    }

    consultar() {
      this.histExpurgoService.one().get(this.serviceVfiltro.getFiltroBackendNovo(this.filtro))
        .then(data => this.setInfoTable(data))
        .catch(() => this.vtabela.setError());
    }

    setInfoTable(data) {
      this.vtabela.setData(data.map(i => this.getItemVtabela(i)));
    }
  }

  /**
   * @ngdoc object
   * @name expurgo.controller:HistExpurgoCtrl
   *
   * @description
   *
   */
  angular
    .module('histExpurgo')
    .controller('HistExpurgoCtrl', HistExpurgoCtrl);
}());
